import { Pipe, PipeTransform } from '@angular/core';

/**
 * add dashes to a phone number string.
 *
 */
@Pipe({ name: 'adddashes' })
export class AddDashesPipe implements PipeTransform {
    transform(value: string): string {
        if (!value) {
            return value;
        }

        if (typeof value === 'string' && /^\d+$/.test(value)) {
            const tmp = value.replace(/\D[^\.]/g, '');
            return tmp.slice(0, 3) + '-' + tmp.slice(3, 6) + '-' + tmp.slice(6);
        }
    }
}
